import { coreTranslations } from 'translations';

export const subTilesConfig = [
    {
        title: coreTranslations.ng_core_publicFeeds,
        description: coreTranslations.ng_core_publicFeedsDescription,
        path: '/public-feeds',
        visible: access => access.canManageIntegrations()
    },
    //all the below go to "under construction pages in OUI, not sure why
    {
        title: coreTranslations.ng_core_chat,
        description: coreTranslations.ng_core_chatDescription,
        path: '/chat',
        visible: () => false
    },
    {
        title: coreTranslations.ng_core_guardianSDS,
        description: coreTranslations.ng_core_guardianSDSDescription,
        path: '/guardian-sds',
        visible: () => false
    },
    {
        title: coreTranslations.ng_core_alertus,
        description: coreTranslations.ng_core_alertusDescription,
        path: '/alertUs',
        visible: () => false
    },
    {
        title: coreTranslations.ng_core_apiKeys,
        description: coreTranslations.ng_core_apiKeysDescription,
        path: '/apisettings',
        visible: () => false
    },
    {
        title: coreTranslations.ng_core_ivrManager,
        description: coreTranslations.ng_core_ivrManagerDescription,
        path: '/ivr-opt-in',
        visible: () => false
    }
];
